export default function maxArrayUtil (array) {
  if (!array || array.length === 0) {
    return undefined
  }
  return Math.max(...array)
}
